import React from 'react';
import { Pressable, View } from 'react-native';
import Text from '@/components/Typography/Text';
import { useTheme } from '@/context/ThemeContext';

const STEPS = ['Name', 'Purpose', 'Instructions', 'Avatar'];

export default function BotSetupProgress({ step = 0, disabled = false, onStepChange }) {
  const { colors } = useTheme();
  return <View style={{ flexDirection: 'row', gap: 8 }} accessibilityLabel="Bot setup progress">
    {STEPS.map((label, index) => {
      const complete = index < step;
      const current = index === step;
      return <Pressable key={label} disabled={disabled || !complete || !onStepChange}
        onPress={() => onStepChange(index)} accessibilityRole="button" accessibilityLabel={`Back to ${label}`}
        accessibilityState={{ selected: current, disabled: disabled || !complete || !onStepChange }}
        style={{ flex: 1, minHeight: 60, gap: 8, alignItems: 'center' }}>
        <View style={{ width: 28, height: 28, borderRadius: 14, alignItems: 'center', justifyContent: 'center', borderWidth: 1,
          borderColor: complete || current ? colors.text_color_primary : colors.border_color_primary,
          backgroundColor: complete || current ? colors.text_color_primary : colors.solid_color_primary }}>
          <Text size="xs" weight="medium" style={{ color: complete || current ? colors.accent_text_color : colors.text_color_secondary }}>{complete ? '✓' : index + 1}</Text>
        </View>
        <Text size="xxs" weight={current ? 'semibold' : 'regular'} color={current ? 'primary' : 'secondary'}>{label}</Text>
      </Pressable>;
    })}
  </View>;
}
